
























import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { EnrollmentOption, Permission } from "@/shared/types";
import * as RouteNames from "@/employer/route-names";
import { useUserStore } from "@/shared/store/user";
import { useProfileStore } from "@/employer/store/profile";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component
export default class AddEmployeeLinkWidget extends Vue {
  userStore = useUserStore();
  profileStore = useProfileStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop() displayReportLink;

  RouteNames = RouteNames;
  isLoaded = false;

  mounted () {
    this.onEnrollmentOptionLoadedChange();
  }

  @Watch("profileStore.enrollmentOptionLoaded")
  onEnrollmentOptionLoadedChange () {
    if (this.profileStore.enrollmentOptionLoaded) {
      this.isLoaded = true;
    } else {
      this.profileStore.loadEnrollmentOption(this.userStore.currentEmployer.employerId);
    }
  }

  get isEmployerTerminated (): boolean {
    return this.userStore.currentEmployer && this.userStore.currentEmployer.isTerminated;
  }

  get hasEmployeeWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.EmployeeWrite);
  }

  get isBulkEmployer (): boolean {
    return this.profileStore.enrollmentOption === EnrollmentOption.EmployerBulk;
  }

  get showLink (): boolean {
    return this.hasEmployeeWritePermission && !this.isBulkEmployer;
  }
}

